'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _digest = require('./digest.js');

var from = function from(_ref) {
  var name = _ref.name,
      code = _ref.code,
      encode = _ref.encode;
  return new Hasher(name, code, encode);
};

var Hasher = /*#__PURE__*/function () {
  function Hasher(name, code, encode) {
    _classCallCheck(this, Hasher);

    this.name = name;
    this.code = code;
    this.encode = encode;
  }

  _createClass(Hasher, [{
    key: "digest",
    value: function digest(input) {
      var _this = this;

      if (input instanceof Uint8Array) {
        var result = this.encode(input);
        return result instanceof Uint8Array ? _digest.create(this.code, result) : result.then(function (digest$1) {
          return _digest.create(_this.code, digest$1);
        });
      } else {
        throw Error('Unknown type, must be binary type');
      }
    }
  }]);

  return Hasher;
}();

exports.Hasher = Hasher;
exports.from = from;